'use strict';
import { cn_wall } from '../model/cn_wall';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_svg_map } from './cn_svg_map';
import { cn_type_pastille } from './cn_type_pastille';
import { cn_edit_box } from './cn_edit_box';
import { cn_pastille } from './cn_pastille';
import { cn_wall_type } from '../model/cn_wall_type';
import { cn_balcony_type } from '../model/cn_balcony_type';
import { cn_fence_type } from '../model/cn_fence_type';
import { cn_add, cn_barycenter, cn_intersect_line, cn_middle, cn_mul, cn_sub } from '../utils/cn_utilities';
import { cn_plugin_option } from '../utils/cn_plugin_option';
import { cn_mouse_event } from './cn_mouse_event';

export class cn_wall_handler extends cn_edition_handler {
    //***********************************************************************************
    /**
     * Constructor
     * @param {Array<cn_wall>} walls
     * @param {cn_svg_map} map
     * @param {boolean} creation
     */
    constructor(walls, map, creation = false) {
        super(walls, map);

        this._map = map;
        this._scene = this._map._scene;
        this._transaction_manager = this._map._building.transaction_manager;
        const obj = this;

        //*** pipe
        this.walls = walls;

        //*** Edit box for mass selection */
        const edit_box = new cn_edit_box(this, walls, this._readOnly);
        this._handlers.push(edit_box);

        let coherent = true;
        let wall_type_constructor = null;
        walls.forEach(w => {
            if (wall_type_constructor == null)
                wall_type_constructor = w.wall_type.constructor;
            else if (wall_type_constructor != w.wall_type.constructor)
                coherent = false;
        });

        if (coherent) {
            if (!this._readOnly) {
                //*** Type pastille */
                const transaction_name = (wall_type_constructor == cn_wall_type) ? 'Type de mur' : (wall_type_constructor == cn_balcony_type) ? 'Type de balcon' : 'Type de clôture';
                const type_pastille = new cn_type_pastille(walls, 'wall_type', () => {
                    if (wall_type_constructor == cn_wall_type)
                        return map._building.get_wall_types();
                    else if (wall_type_constructor == cn_balcony_type)
                        return map._building.get_balcony_types();
                    else if (wall_type_constructor == cn_fence_type)
                        return map._building.get_fence_types();
                }, transaction_name, map);
                type_pastille.title = 'Modifier le type de mur';
                type_pastille.checkbox_label = 'Inverser la composition';
                type_pastille.on("clicked", () => {
                    type_pastille.checkbox_status = walls[0].flip_wall_type;
                });
                type_pastille.on("callback", () => {
                    walls.forEach(w => {
                        this._transaction_manager.push_item_set(w, ["flip_wall_type"]);
                        w.flip_wall_type = type_pastille.checkbox_status;
                    });
                });
                if (wall_type_constructor == cn_wall_type) {
                    type_pastille.on("pre_input", (input) => {
                        input.allow_multiple_types = cn_plugin_option.vertical_walls && !walls[0].dormer;
                        input.multiple_types_value_label = "Hauteur";
                        input.multiple_types = walls[0].upper_wall_types.map((wt, i) => { return { selection: input.choices.indexOf(wt), value: walls[0].upper_heights[i] }; });
                        input.multiple_type_checker = (wt) => { return wt.vertical_compatible(); }
                    });
                    type_pastille.on("post_input", (input) => {
                        walls.forEach(wall => {
                            map._building.transaction_manager.push_item_set(wall, ["upper_wall_types", "upper_heights"]);
                            wall.upper_wall_types = input.multiple_types.map(mt => input.choices[mt.selection]);
                            wall.upper_heights = input.multiple_types.map(mt => mt.value);
                        });
                    });
                }
                edit_box.add_pastille(type_pastille);

                edit_box.add_lock_pastille(this._transaction_manager);
            }

            edit_box.add_select_siblings_pastille('wall_type');
            edit_box.add_information_pastille('wall_type');
        }

        if (!this._readOnly) {
            //*** axis pastille */
            const axis_pastille = new cn_pastille([0, 0], 'switch_wall_axis.png');
            edit_box.add_pastille(axis_pastille);
            axis_pastille.svg_class = 'pastille_background white';
            axis_pastille.title = 'Modifier l\'axe des murs';
            axis_pastille.clicked = () => {
                obj.set_wall_axis((1 + obj.walls[0].axis) % 3);
            }
        }

    }

    //*** Set wall axis for selection
    set_wall_axis(axis) {
        this._scene.set_walls_axis(this.walls, axis, this._transaction_manager);
    }
}

